import Form from "./Form";

function Home() {
  return (
    <>
      <div className="my-5">
        <Form />
      </div>
    </>
  );
}
export default Home;
